<template>
  <div
    :class="[
      { open: isOpen },
      { dropdown: direction === 'down' },
      { dropup: direction === 'up' },
    ]"
    @click="toggleDropDown"
    @mouseover="openAfter"
    @mouseleave="closeBefore"
    v-click-outside="closeDropDown"
    ref="inputDiv"
  >
    <slot name="title">
      <a
        class="dropdown-toggle"
        data-toggle="dropdown"
        href="javascript:void(0)"
      >
        <i :class="icon"></i>
        <p class="notification">
          {{ title }}
          <b class="caret"></b>
        </p>
      </a>
    </slot>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'input-plus',
  props: {
    title: String,
    icon: String,
    values: Object,
    direction: {
      type: String,
      default: 'down',
    },
  },
  data() {
    return {
      isOpen: false,
      readyToOpen: false,
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = this.values.checkAgainst !== this.values.defaultValue;
      if (!this.isOpen) this.$emit('close-dropdown', true);
      else if (this.isOpen) this.$emit('open-dropdown', true);
    },
    closeDropDown() {
      this.isOpen = false;
    },
    closeBefore() {
      this.readyToOpen = false;
    },
    openAfter() {
      if (
        !this.isOpen &&
        !this.readyToOpen &&
        this.values.checkAgainst !== this.values.defaultValue
      ) {
        this.readyToOpen = true;
        window.setTimeout(() => {
          if (this.readyToOpen) {
            this.isOpen = this.values.checkAgainst !== this.values.defaultValue;
            if (!this.isOpen) this.$emit('close-dropdown', true);
            else if (this.isOpen) this.$emit('open-dropdown', true);
          }
        }, 600);
      }
    },
  },
  watch: {
    isOpen(value) {
      if (!value && this.$refs.inputDiv.childNodes.length > 1)
        this.$emit('close-dropdown', true);
    },
  },
  // ,
  // mounted() {
  //   // hasAddArgs() {

  //   // }
  //    if (this.$refs.inputDiv.childNodes.length) {
  //    }
  // }
};
</script>
